<template>
  <ReactSiteFrame :src="src" />
</template>

<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'DriverUnitsReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/units'
    }
  }
}
</script>
